import { render, staticRenderFns } from "./ProfileFriend.vue?vue&type=template&id=cb9c448c&scoped=true&lang=html&"
import script from "./ProfileFriend.vue?vue&type=script&lang=js&"
export * from "./ProfileFriend.vue?vue&type=script&lang=js&"
import style0 from "./ProfileFriend.vue?vue&type=style&index=0&id=cb9c448c&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb9c448c",
  null
  
)

export default component.exports